import { Routes } from '@angular/router';
import { CopMatrixPopupComponent } from './cop-matrix.component';

export const COP_ROUTES: Routes = [{
    path: 'cop-matrix',
    component: CopMatrixPopupComponent,
    outlet: 'popup'
}];
